import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';

export function NoTenantAccessPage() {
  const { user, logout } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>No program access</h1>
        <p>
          {user?.authKind === 'platform'
            ? 'Your platform administrator account does not use tenant program workspaces.'
            : 'Your account is signed in, but it is not linked to a program. Contact your administrator or wait for an invitation.'}
        </p>
        {user?.authKind === 'platform' && (
          <Link to="/platform" className="btn btn--secondary">Open platform administration</Link>
        )}
        <button type="button" className="btn btn--primary" onClick={() => logout()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
